export const remToPx = (rems, base = 16) => parseInt(rems) * base;
//# sourceMappingURL=remToPx.js.map